export const archiveReasons = [
  { label: "not_an_order", value: "not-an-order" },
  { label: "other", value: "other" },
  { label: "hand_processed", value: "hand-processed" },
  { label: "duplicate", value: "duplicate" },
  { label: "order_error", value: "order_error" },
  { label: "customer_not_available", value: "customer_not_available" },
];
